angular.module('impactx.ruleset').controller('RuleUserCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'RuleUserService',
    'TranslationService',
    '$filter',
    'ToolbarService',
    RuleUserCtrl
]);

function RuleUserCtrl($scope, dataGen, $routeParams, RuleUserService, TranslationService, $filter, ToolbarService) {
    var self = this;

    dataGen.getData($scope, {ateId: $routeParams.ATEId, atpId: $routeParams.ATPId}, '/ruleuser/default/view')
        .then(function () {
            $scope.trns.delete = TranslationService.get('delete');
            $scope.trns.save = TranslationService.get('save');
            $scope.refTable = $routeParams.refTable;

            var aatMod = getAATMod();
            self.checkAccounting(aatMod.isEnabled.value, "AAT");
            self.checkAccountingRights(aatMod.selection.setId, "AAT");
            self.checkCateringModification();

            defineButtons();
        });

    self.saveRuleUser = function () {
        return RuleUserService.saveRuleUser($scope);
    };

    self.deleteRuleUser = function () {
        return RuleUserService.deleteRuleUser($scope);
    };

    self.toggleRuleUserType = function (ruleType) {
        RuleUserService.toggleRuleUserType($scope, ruleType);
    };

    self.hasNoSelectedApprover = function () {
        return RuleUserService.hasNoSelectedApprover($scope);
    };

    self.clearChangeType = function (notificationEnabled, modificationEnabled) {
        RuleUserService.clearChangeType($scope, notificationEnabled, modificationEnabled)
    };

    self.setRoles = function (selected) {
        // only a concrete role (id > 0) clears the other approver fields - the empty option
        // must not wipe responsibilities, users and rule user types (IOBL-15516)
        if (selected && selected.id > 0) {
            $scope.data.roles.selected = selected;
            $scope.data.responsibilities.selected = null;
            $scope.data.users.selected = null;
            self.toggleRuleUserType();
        }
    };

    self.setResponsibilities = function (selected) {
        if (selected) {
            $scope.data.roles.selected = null;
            $scope.data.responsibilities.selected = selected;
            $scope.data.users.selected = null;
            self.toggleRuleUserType();
        }
    };

    self.setUsers = function (selected) {
        if (selected) {
            $scope.data.roles.selected = null;
            $scope.data.responsibilities.selected = null;
            $scope.data.users.selected = selected;
            self.toggleRuleUserType();
        }
    };

    var ctrlIdentifiers = ['CTU', 'CTT', 'CRD', 'PRJ', 'CTRLA', 'CTRLB', 'CTRLC', 'CTRLD', 'PSP', 'ASN', 'INO', 'LOC', 'ACT', 'NET', 'EKO', 'EKG'];
    var ctrlMods;
    var getCtrlMods = function () {
        if (!ctrlMods) {
            ctrlMods = $filter('filter')($scope.data.approvalModification, function (mod) {
                for (var i = 0; i < ctrlIdentifiers.length; i++) {
                    if (mod.isEnabled.identifier === ctrlIdentifiers[i]) {
                        return true;
                    }
                }
                return false;
            });
        }
        return ctrlMods;
    };


    var getAATMod = function () {
        return $filter('filter')($scope.data.approvalModification, function (mod) {
            return mod.isEnabled.identifier === "AAT";
        })[0];
    };

    self.checkAccounting = function (value, identifier) {
        if (identifier === "AAT") {
            angular.forEach(getCtrlMods(), function (mod) {
                if (value) {
                    mod.isEnabled.value = true;
                }
                mod.isEnabled.readOnly = value;
            });
        }
    };

    self.checkAccountingRights = function (value, identifier) {
        if (identifier === "AAT") {
            angular.forEach(getCtrlMods(), function (mod) {
                mod.selection.setId = value;
            });
        }
    };

    self.checkCateringModification = function () {
        if ($scope.data.isCateringStep) {
            // this is actually just for show: the approval dialog does not check approval modification flags, since it is very specialized
            var cateringMods = $scope.data.approvalModification.filter(function (entry) {
                return entry.isEnabled.identifier === "INCOMMENT" || entry.isEnabled.identifier === "AMOUNT"
            });
            if ($scope.data.isCateringStep.value && !$scope.data.notificationEnabled.value) {
                $scope.data.modificationEnabled.value = true;
                $scope.data.modificationEnabled.readOnly = true;

                angular.forEach(cateringMods, function (mod) {
                    mod.isEnabled.value = true;
                    mod.isEnabled.readOnly = true;
                });
            }
            else {
                $scope.data.modificationEnabled.readOnly = false;

                angular.forEach(cateringMods, function (mod) {
                    mod.isEnabled.readOnly = false;
                });
            }
        }
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: self.saveRuleUser,
                type: 'validation',
                params: {
                    form: $scope.dialogData,
                    disableExpression: {valueFunction: disableSave, error: $scope.trns.selectOneApprover}
                }
            },
            {
                label: $scope.trns.delete,
                action: self.deleteRuleUser,
                type: 'dialogaction'
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function disableSave() {
        return self.hasNoSelectedApprover();
    }
}